// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    Handler,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { AddToWishListParameter, chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";

interface Props {
    result: {
        wishList?: WishListModel;
        errorMessage?: string;
    };
}

type HandlerType = Handler<AddToWishListParameter, Props>;


export const XngExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.result?.errorMessage && props.parameter.onSuccess) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess(props.result.wishList!);
        props.dispatch({
            type: "xWishLists/ProductSuccessfullyAdded",
            productId: props.parameter?.productInfos?.[0]?.productId,
        } as any);
    }
};

replaceInChain(chain, ExecuteOnSuccessCallback, XngExecuteOnSuccessCallback);
